import React from "react";

const Checkbox = ({
  label,
  inputClassName,
  className,
  disabled,
  input,
  change,
}) => {
  return (
    <label
      className={`checkbox-label group inline-flex items-center gap-2.5 transition-colors ${
        disabled ? "cursor-not-allowed opacity-70" : "hover:text-purple-900 dark:hover:text-purple-300"
      } ${className || ""}`}
    >
      <input
        type="checkbox"
        className={`input peer h-5 w-5 cursor-pointer rounded-md transition-all duration-200 checked:bg-purple-900 checked:ring-2 checked:ring-purple-200 checked:ring-offset-1 hover:border-purple-400 focus:ring-2 focus:ring-purple-300 focus:ring-offset-1 disabled:cursor-not-allowed disabled:checked:bg-purple-900 disabled:checked:opacity-50 dark:checked:ring-purple-800 dark:checked:ring-offset-gray-900 dark:hover:border-purple-500 dark:focus:ring-purple-700 dark:focus:ring-offset-gray-900 dark:disabled:checked:bg-purple-800 ${inputClassName || ""}`}
        disabled={disabled}
        {...input}
        onChange={change || input.onChange}
      />
      <span className="select-none text-[15px]">{label}</span>
    </label>
  );
};

export default React.memo(Checkbox);
